import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TwillioEmailConfirmData } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: TwillioEmailConfirmData) =>
    $actions.user.confirmEmailByTwilio(dispatch, values),
  );
};
